import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockSectionFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const sectionBlockConfig = {
  name: 'outer-block-section',
  component: defineAsyncComponent(() => import('./CmsSection.vue')),
  innerComponent: defineAsyncComponent(() => import('./Section.vue')),
  fields: blockSectionFields,
} satisfies ModularBlockConfig;
